<template>
    <div style="width:90%;margin:0 auto;display:block;">
            <p style="padding-top:50px;text-align:center;text-transform: uppercase;font-size:25px;
            font-weight:600;color:#ccc;line-height:35px;
            ">
              Tunnels/Cable & Conduit
            </p>

            <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        When it comes to underground structures, 
                        bypasses and bridges, using traditional 
                        PVC conduit can be difficult, time consuming and 
                        does not allow easy room for future growth.
                    </p>


                    <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        With <strong>Pipe Me In Products</strong>, some of this issues can be easily resolved. Our unique two, 
                        three and four side conduit solution can easily section each pipe to allow 
                        different provider to add or removed cables as many times as needed. Less 
                        conduit equal less space and fewer hours of labor and permits. 
                    </p>

                    <v-layout row justify-center>
                        <v-flex xs12 md4>
                            <v-img style="margin:0 auto;display:block;
                            " src="@/assets/planito1.png"></v-img>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-img style="width:80%;margin:50px auto;display:block;
                            " src="@/assets/planito2.png"></v-img>
                        </v-flex>
                        <v-flex xs12 md4>
                            <div>
                                <v-img style="
                                width:60%;margin:100px auto;display:block;
                            " src="@/assets/planito3.png"></v-img>
                            </div>
                        </v-flex>
                    </v-layout>

                    
                    <v-layout row justify-center class="hidden-sm-and-down" style="margin:100px 0 100px 0;">
                        <v-flex xs12 md6>
                            <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        Another advantage of our conduit is the ability to bypass 
                        junction boxes depending on the project.
                    </p>
                    <v-img style="margin:0 auto;display:block;
                            " width="350" src="@/assets/noconnect.png"></v-img>
                            <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        Just cut a section on the conduit in which you would 
                        like the cables to exit and you are done! <br><br>

                        Run your cables first and worry about the conduit last.

                    </p>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-img style="margin:0 auto;display:block;
                            " src="@/assets/tuboconcable.jpg"></v-img>
                        </v-flex>
                    </v-layout>

                    <v-layout row justify-center class="hidden-sm-and-up" style="margin:100px 0 100px 0;">
                        <v-flex xs12 md6>
                            <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        Another advantage of our conduit is the ability to bypass 
                        junction boxes depending on the project.
                    </p>
                    <v-img style="margin:0 auto;display:block;
                            " width="350" src="@/assets/noconnect.png"></v-img>
                        </v-flex>
                        <v-flex xs12 md6>
                            <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        Just cut a section on the conduit in which you would 
                        like the cables to exit and you are done! <br><br>

                        Run your cables first and worry about the conduit last.

                    </p>
                    <v-img style="margin:0 auto;display:block;
                            " src="@/assets/tuboconcable.jpg"></v-img>
                        </v-flex>
                    </v-layout>


                    



    </div>
</template>

<style>
.fotisos {
    vertical-align: middle;
}
</style>

<script>
export default {
    data(){
        return {
            items: [
          {
            src: 'https://pipemein.com/img/img_cable_0.jpg',
          },
          {
            src: 'https://pipemein.com/img/img_cable_1.jpg',
          },
          {
            src: 'https://pipemein.com/img/img_cable_2.jpg',
          }
        ],
        }
    }
}
</script>